export function getObjectData(objectDefinition) {
  return {
    category: objectDefinition.category,
    type: objectDefinition.type,
  };
}
